import Component from '../../../../../../pages/vpp/features/buybox/returns-summary/returns-summary.desktop';

export default Component;
